import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
// image
import logo from "../../images/freshment.png";
import logo2 from "../../images/TwoFV.png";
import backArrow from "../../images/back_arrow.png";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { API_URL } from "../../config";
import {
  runLogoutTimer,
  saveTokenInLocalStorage,
} from "../../services/AuthService";
import { loginConfirmedAction } from "../../store/actions/AuthActions";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import freshmentlogo from "../../images/freshmentLogo1.png";
import { logoutonexpire } from "../../store/actions/AuthActions";
import { fetchCourses } from "../../store/actions/CourseAction";
import { Spinner } from "react-bootstrap";
import {
  Lock,
  ShieldCheck,
  CheckCircle2,
  XCircle,
  RefreshCw,
  LogIn,
} from "lucide-react";
import { motion } from "framer-motion";
const TwoFactor = ({ history }) => {
  const collegeId = useSelector((state) => state.college_id.college_id);
  const [Otp, setOtp] = useState("");
  const [trusted, setTrusted] = useState(0);
  const [result] = useState(
    localStorage.getItem("TempUserDetails")
      ? JSON.parse(localStorage.getItem("TempUserDetails"))
      : null,
  );
  const dispatch = useDispatch();
  const [ipAddress, setIpAddress] = useState(
    localStorage.getItem("user_ip_address") || "127.0.0.1",
  );
  const [location, setLocation] = useState(
    localStorage.getItem("user_location") || "unknown",
  );
  const [deviceInfo, setDeviceInfo] = useState(
    localStorage.getItem("user_device_info") || "",
  );
  const [isResending, setIsResending] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [countdown, setCountdown] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const [otpValues, setOtpValues] = useState(["", "", "", "", "", ""]);
  const inputRefs = [
    React.useRef(),
    React.useRef(),
    React.useRef(),
    React.useRef(),
    React.useRef(),
    React.useRef(),
  ];
  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState(null);

  // Handle OTP input change
  const handleOtpChange = (index, value) => {
    // Only allow numbers
    value = value.replace(/[^0-9]/g, "");
    if (value.length > 1) {
      value = value.slice(0, 1);
    }
    const newValues = [...otpValues];
    newValues[index] = value;
    setOtpValues(newValues);
    setOtp(newValues.join(""));

    // Auto-focus next input
    if (value && index < 5) {
      inputRefs[index + 1].current.focus();
    }
  };

  // Handle key down for backspace navigation
  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otpValues[index] && index > 0) {
      inputRefs[index - 1].current.focus();
    }
  };

  // Handle paste
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData
      .getData("text")
      .replace(/[^0-9]/g, "")
      .slice(0, 6);
    const newValues = [...otpValues];
    pastedData.split("").forEach((char, i) => {
      if (i < 6) {
        newValues[i] = char;
      }
    });
    setOtpValues(newValues);
    setOtp(newValues.join(""));
    // Focus the last filled input or the next empty one
    const nextIndex = Math.min(pastedData.length, 5);
    inputRefs[nextIndex].current.focus();
  };

  // Countdown timer for OTP resend
  useEffect(() => {
    if (countdown > 0) {
      const timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    } else {
      setCanResend(true);
    }
  }, [countdown]);

  // Reset countdown when OTP is resent
  const startCountdown = () => {
    setCountdown(30);
    setCanResend(false);
  };

  // Fetch IP address and location if not already in localStorage
  useEffect(() => {
    const fetchIpAndLocation = async () => {
      // If we already have values from localStorage, use those
      if (
        localStorage.getItem("user_ip_address") &&
        localStorage.getItem("user_location") &&
        localStorage.getItem("user_device_info")
      ) {
        return;
      }

      try {
        // Try ipify first
        const ipResponse = await axios.get("https://api.ipify.org?format=json");
        const ipAddr = ipResponse.data.ip;
        setIpAddress(ipAddr);

        // Then get location from ip-api
        const locationResponse = await axios.get(
          `http://ip-api.com/json/${ipAddr}`,
        );
        const loc =
          `${locationResponse.data.city}, ${locationResponse.data.country}` ||
          "unknown";
        setLocation(loc);

        // Store in localStorage
        localStorage.setItem("user_ip_address", ipAddr);
        localStorage.setItem("user_location", loc);
      } catch (error) {
        // Fallback to alternative API if first attempt fails
        try {
          const response = await axios.get("https://ipwho.is/");
          const ipAddr = response.data.ip;
          const loc =
            `${response.data?.city}, ${response.data?.country}` || "unknown";
          setIpAddress(ipAddr);
          setLocation(loc);

          // Store in localStorage
          localStorage.setItem("user_ip_address", ipAddr);
          localStorage.setItem("user_location", loc);
        } catch (fallbackError) {
          console.error("Error fetching IP or location:", fallbackError);
          // Use fallback values
          setIpAddress("127.0.0.1");
          setLocation("unknown");

          // Store fallback values in localStorage
          localStorage.setItem("user_ip_address", "127.0.0.1");
          localStorage.setItem("user_location", "unknown");
        }
      }

      // Get and store device info
      const deviceInfoValue = getDeviceInfo();
      setDeviceInfo(deviceInfoValue);
    };

    fetchIpAndLocation();
  }, []);

  const getDeviceInfo = () => {
    if (navigator.userAgentData) {
      const deviceInfoValue = navigator.userAgentData.brands
        .map((brand) => `${brand.brand} ${brand.version}`)
        .join(", ");
      localStorage.setItem("user_device_info", deviceInfoValue);
      return deviceInfoValue;
    } else {
      const deviceInfoValue = navigator.userAgent; // Fallback to userAgent
      localStorage.setItem("user_device_info", deviceInfoValue);
      return deviceInfoValue;
    }
  };

  useEffect(() => {
    if (!ipAddress || !location) return;
    if (localStorage.getItem("otp_already_generated")) {
      return;
    }

    const params = new URLSearchParams();
    params.append("college_connect_id", result?.data?.college_id);
    params.append("ip_address", ipAddress);
    params.append("device_info", deviceInfo || getDeviceInfo());
    params.append("location", location);

    const userDetails = JSON.parse(localStorage.getItem("TempUserDetails"));
    const authToken = userDetails?.data?.auth_token;
    axios
      .post(
        `${API_URL}/api/freshment_portal_apis/college/generate_twofactor_otp`,
        params,
        {
          headers: {
            Authorization: authToken,
          },
        },
      )
      .then((response) => {
        Swal.close();
        if (response.data.success === true) {
          localStorage.setItem("otp_already_generated", "true");
        } else {
          setMessage(response.data.message);
          setMessageType("error");
        }
      })
      .catch((e) => {
        if (e?.response?.status === 401) {
          dispatch(logoutonexpire());
        }
        setMessage(
          "An error occurred while generating the OTP, Please Resend the OTP or come again to this page",
        );
        setMessageType("error");
      });
  }, [ipAddress, location, deviceInfo, collegeId]);

  const resendOTP = () => {
    setIsResending(true);
    const userDetails = JSON.parse(localStorage.getItem("TempUserDetails"));
    const authToken = userDetails?.data?.auth_token;

    const payload = {
      is_trusted: trusted,
    };

    localStorage.removeItem("otp_already_generated");

    const params = new URLSearchParams();
    params.append("college_connect_id", result?.data?.college_id);
    params.append("ip_address", ipAddress);
    params.append("device_info", deviceInfo || getDeviceInfo());
    params.append("location", location);
    params.append("is_trusted", payload.is_trusted);

    Swal.fire({
      title: "Processing...",
      text: "Please wait while we resend the OTP",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    axios
      .post(
        `${API_URL}/api/freshment_portal_apis/college/generate_twofactor_otp`,
        params,
        {
          headers: {
            Authorization: authToken,
          },
        },
      )
      .then((response) => {
        Swal.close();
        setIsResending(false);
        if (response.data.success) {
          setMessage("A new OTP has been sent to your email.");
          setMessageType("success");
          startCountdown();
        } else {
          setMessage(response.data.message);
          setMessageType("error");
        }
      })
      .catch((e) => {
        Swal.close();
        setIsResending(false);
        if (e?.response?.status === 401) {
          dispatch(logoutonexpire());
        }
        console.log(e);
        setMessage("Failed to resend OTP. Please try again.");
        setMessageType("error");
      });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true); // Start loading
    const payload = {
      is_trusted: trusted,
    };
    const params = new URLSearchParams();
    params.append("otp", Otp);
    params.append("college_id", result?.data?.college_id);
    params.append("is_trusted", payload.is_trusted);
    const userDetails = JSON.parse(localStorage.getItem("TempUserDetails"));
    const authToken = userDetails?.data?.auth_token;

    Swal.fire({
      title: "Processing...",
      text: "Please wait while we verify your OTP",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    axios
      .post(
        `${API_URL}/api/freshment_portal_apis/College/verify_twofactor_auth`,
        params,
        {
          headers: {
            Authorization: authToken,
          },
        },
      )
      .then((res) => {
        Swal.close();
        setIsSubmitting(false); // Stop loading
        if (res.data.success == true) {
          toast.success(res.data.message, {
            onOpen: () => {
              saveTokenInLocalStorage(result);
              runLogoutTimer(dispatch, result.expiresIn * 1000, history);
              dispatch(loginConfirmedAction(result));
              history.push("/dashboard");
              localStorage.removeItem("TempUserDetails");
              localStorage.removeItem("otp_already_generated");
              const payload = {
                college_id: result?.data?.college_id,
              };
              dispatch(fetchCourses(payload));
            },
          });
        } else {
          setMessage(res.data.message);
          setMessageType("error");
        }
      })
      .catch((err) => {
        Swal.close();
        setIsSubmitting(false); // Stop loading
        if (err?.response?.status === 401) {
          dispatch(logoutonexpire());
        }
        console.log("err======", err);
        setMessage("Failed to verify OTP. Please try again.");
        setMessageType("error");
      });
  };

  return (
    <div
      className="position-relative d-flex align-items-center justify-content-center overflow-hidden"
      style={styles.page}
    >
      {/* Background blobs */}
      <div className="position-absolute" style={styles.blobTop} />
      <div className="position-absolute" style={styles.blobBottom} />

      <motion.div
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-100 bg-white shadow position-relative d-flex flex-column gap-4"
        style={styles.card}
      >
        <div className="text-center">
          <div
            className="mx-auto d-flex align-items-center justify-content-center rounded-4 shadow-sm mb-3"
            style={styles.iconBox}
          >
            <Lock style={{ width: "24px", height: "24px", color: "#FF5F14" }} />
          </div>
          <h1 className="fw-bold font-display" style={styles.heading}>
            2FA verification
          </h1>
          <p className="mt-2" style={styles.subtext}>
            EduConnectPro utilizes mandatory Two-Factor Authentication (2FA) for
            security purposes. Enter the code sent to your registered email.
          </p>
        </div>

        <form
          onSubmit={(e) => onSubmit(e)}
          className="d-flex flex-column gap-4"
        >
          {message && (
            <div
              style={
                messageType === "success" ? styles.successBox : styles.errorBox
              }
            >
              <div className="d-flex flex-column gap-1">
                {messageType === "success" ? (
                  <>
                    <div className="d-flex align-items-center gap-2">
                      <CheckCircle2
                        style={{
                          width: "16px",
                          height: "16px",
                          color: "#059669",
                          flexShrink: 0,
                        }}
                      />
                      <span
                        style={{
                          fontSize: "0.875rem",
                          color: "#059669",
                          fontWeight: "700",
                        }}
                      >
                        Security Verified
                      </span>
                    </div>
                    <span
                      style={{
                        fontSize: "0.75rem",
                        color: "#065f46",
                        marginLeft: "24px",
                      }}
                    >
                      {message}
                    </span>
                  </>
                ) : (
                  <div className="d-flex align-items-start gap-2">
                    <XCircle
                      style={{
                        width: "16px",
                        height: "16px",
                        color: "#dc2626",
                        flexShrink: 0,
                        marginTop: "2px",
                      }}
                    />
                    <span style={{ fontSize: "0.75rem", color: "#991b1b" }}>
                      {message}
                    </span>
                  </div>
                )}
              </div>
            </div>
          )}

          <div className="d-flex flex-column gap-2">
            <label className="fw-bold d-block" style={styles.label}>
              Enter Your Code
            </label>
            <div className="d-flex input-boxes justify-content-center">
              {otpValues.map((value, index) => (
                <input
                  key={index}
                  ref={inputRefs[index]}
                  type="text"
                  value={value}
                  onChange={(e) => handleOtpChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  onPaste={handlePaste}
                  maxLength={1}
                  className="fw-bold text-center otp-single-input"
                  style={styles.otpInput}
                />
              ))}
            </div>
          </div>

          <div className="d-flex align-items-center gap-2">
            <input
              type="checkbox"
              id="remember_me"
              className="form-check-input remember-checkbox"
              onChange={(e) => setTrusted(e.target.checked ? 1 : 0)}
              checked={trusted == 0 ? false : true}
              style={styles.checkbox}
            />
            <label
              htmlFor="remember_me"
              className="fw-semibold mb-0"
              style={styles.checkboxLabel}
            >
              Remember Me For 30 Days
            </label>
          </div>

          <button
            type="submit"
            disabled={isResending || isSubmitting}
            className="w-100 orangeBtn d-flex align-items-center justify-content-center gap-2 text-uppercase fw-bold border-0 mt-2"
            style={{
              ...styles.submitButton,
              opacity: isResending || isSubmitting ? 0.5 : 1,
            }}
          >
            <span>Verify Secure OTP</span>
          </button>

          <div className="d-flex justify-content-between align-items-center mt-2">
            <span
              onClick={() => canResend && resendOTP()}
              style={{
                ...styles.resendText,
                opacity: isResending || isSubmitting || !canResend ? 0.5 : 1,
                cursor: canResend ? "pointer" : "default",
              }}
            >
              <RefreshCw
                style={{
                  width: "14px",
                  height: "14px",
                  animation: isResending
                    ? "twofaSpin 0.8s linear infinite"
                    : "none",
                  display: "inline",
                  verticalAlign: "middle",
                }}
              />
              <span style={{ marginLeft: "6px" }}>
                {isResending ? "Resending..." : "Resend Secure OTP"}
              </span>
            </span>
            {!canResend && (
              <span className="font-mono" style={styles.timerText}>
                Resend in{" "}
                <span style={{ fontWeight: "700" }}>{countdown}s</span>
              </span>
            )}
          </div>
        </form>

        <div
          className="d-flex align-items-center justify-content-center pt-2"
          style={styles.loginRow}
        >
          <a
            href="/login"
            className="d-flex orange-color-hover align-items-center gap-2 fw-semibold text-decoration-none"
            style={styles.backLink}
          >
            <LogIn style={{ width: "16px", height: "16px" }} />
            <span>Return to Login Screen</span>
          </a>
        </div>

        {/* Safety standards logo */}
        <div
          className="d-flex align-items-center justify-content-center gap-2 text-uppercase fw-bold pt-2"
          style={styles.footer}
        >
          <ShieldCheck
            style={{ width: "14px", height: "14px", color: "#059669" }}
          />
          <span className="font-mono fw-bold">EduConnectPro Secured Area</span>
        </div>
      </motion.div>

      <style>{`
        @keyframes twofaSpin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .otp-single-input:focus {
          outline: none;
          border-color: #FF5F14 !important;
          box-shadow: 0 0 0 1px #FF5F14 !important;
        }
        .remember-checkbox {
          cursor: pointer;
        }
          .input-boxes{gap:9px;}

          @media (max-width:  480px)
          {
            .input-boxes{gap:4px;}
          }
      `}</style>
    </div>
  );
};

const styles = {
  page: {
    minHeight: "85vh",
    backgroundColor: "#f8fafc",
    color: "#0f172a",
    fontFamily: "sans-serif",
    padding: "3rem 1rem",
  },
  blobTop: {
    top: "40px",
    left: "40px",
    width: "288px",
    height: "288px",
    borderRadius: "50%",
    backgroundColor: "rgba(255, 95, 20, 0.05)",
    filter: "blur(100px)",
    pointerEvents: "none",
  },
  blobBottom: {
    bottom: "40px",
    right: "40px",
    width: "384px",
    height: "384px",
    borderRadius: "50%",
    backgroundColor: "rgba(255, 95, 20, 0.03)",
    filter: "blur(120px)",
    pointerEvents: "none",
  },
  card: {
    maxWidth: "28rem",
    padding: "2rem",
    border: "1px solid #e2e8f0",
    zIndex: 10,
    borderRadius: "1rem",
  },
  iconBox: {
    width: "48px",
    height: "48px",
    borderRadius: "1rem",
    backgroundColor: "rgba(255, 95, 20, 0.1)",
    border: "1px solid rgba(255, 95, 20, 0.2)",
  },
  heading: {
    fontSize: "1.75rem",
    color: "#020617",
  },
  subtext: {
    fontSize: "0.75rem",
    color: "#64748b",
    lineHeight: "1.5",
  },
  label: {
    fontSize: "0.75rem",
    color: "#334155",
  },
  otpInput: {
    width: "48px",
    height: "56px",
    padding: "0.75rem",
    fontSize: "1.5rem",
    letterSpacing: "0",
    backgroundColor: "#f8fafc",
    border: "2px solid #e2e8f0",
    color: "#020617",
    fontFamily: "monospace",
    borderRadius: "0.75rem",
    textAlign: "center",
  },
  timerText: {
    fontSize: "0.75rem",
    color: "#64748b",
    fontWeight: "600",
  },
  resendText: {
    fontSize: "0.75rem",
    color: "#FF5F14",
    fontWeight: "600",
    textTransform: "uppercase",
  },
  checkbox: {
    width: "16px",
    height: "16px",
    accentColor: "#FF5F14",
    cursor: "pointer",
  },
  checkboxLabel: {
    fontSize: "0.75rem",
    color: "#475569",
    cursor: "pointer",
  },
  resendButton: {
    padding: "0.625rem 1.25rem",
    backgroundColor: "#f1f5f9",
    color: "#334155",
    fontSize: "10px",
    letterSpacing: "0.05em",
    cursor: "pointer",
    borderRadius: "0.75rem",
  },
  submitButton: {
    padding: "0.625rem 1.5rem",
    backgroundColor: "#FF5F14",
    color: "#fff",
    fontSize: "12px",
    fontWeight: "600",
    letterSpacing: "0.05em",
    cursor: "pointer",
    boxShadow: "0 10px 15px -3px rgba(255, 95, 20, 0.1)",
    borderRadius: "0.75rem",
  },
  loginRow: {
    borderTop: "1px solid #f1f5f9",
  },
  backLink: {
    fontSize: "0.75rem",
    color: "#475569",
  },
  footer: {
    fontSize: "10px",
    fontFamily: "monospace",
    color: "#94a3b8",
    letterSpacing: "0.1em",
  },
  successBox: {
    padding: "0.875rem",
    backgroundColor: "#ecfdf5",
    border: "1px solid #a7f3d0",
    fontSize: "0.75rem",
    borderRadius: "0.5rem",
  },
  errorBox: {
    padding: "0.875rem",
    backgroundColor: "#fef2f2",
    border: "1px solid #fecaca",
    fontSize: "0.75rem",
    borderRadius: "0.5rem",
  },
};

export default TwoFactor;
